import { defineMessages } from 'react-intl';

type MessageKeys = 'titleLabel' | 'searchInputPlaceholderLabel';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		titleLabel: {
			id: 'ai-mate.conversation-list-refresh.title.label',
			defaultMessage: 'All chats',
			description:
				'Heading displayed at the top of the all chats page in the conversation list panel.',
		},
		searchInputPlaceholderLabel: {
			id: 'ai-mate.conversation-list-refresh.search-input-placeholder.label',
			defaultMessage: 'Search all chats...',
			description: 'Placeholder text for input box to search conversations',
		},
	});

export default message;
